<template>
  <div>
    <PageTitle
      title="Event List"
      :btnCreate="true"
      :calendarView="true"
      @onChangeViews="changeViews"
      :createRoute="'/event/add'"
      :permission="'Event Create'"
    />

    <List v-if="isvisible" />
    <Calendar v-if="!isvisible" />
  </div>
</template>

<script>
import List from './EventTableList.vue';
import Calendar from './EventCalendar.vue';

export default {
  data() {
    return {
      isvisible: false,
    };
  },
  methods: {
    changeViews(event) {
      this.isvisible = event;
    },
  },
  components: {
    List,
    Calendar,
  },
};
</script>
